import React, { useEffect, useState } from "react";
import { ServiceApi } from "../services/index.service";
import { Backdrop, Button, CircularProgress } from "@mui/material";

const Snapshot = ({ store, tourEnabled = false }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [noimage, setNoImage] = useState("");
  const serviceapi = new ServiceApi();

  useEffect(() => {
    if (store?.intRitasStoreID && !tourEnabled) {
      getPreSellBoardImages();
    }
  }, [store, tourEnabled]);
  const getPreSellBoardImages = async () => {
    setData(null);
    setLoading(true);
    const req = {
      store_id: store?.intRitasStoreID,
    };
    const response = await serviceapi.getSnapShot(req);
    setData(response?.data);
    setNoImage("");
    setLoading(false);
  };
  const handleFullImage = () => {
    const image_window = window.open(data?.actual_image, "_blank");
    image_window.document.write(`
      <html>
        <head>
          <title>${data?.filename}</title>
        </head>
        <body style="text-align: center;">
          <img src="${data?.actual_image}" alt="Example" height="100%">
        </body>
      </html>
`);
  };

  const tourGuideImg = `https://${process.env.REACT_APP_AWS_BUCKET}.s3.amazonaws.com/${process.env.REACT_APP_DMB_END_POINT_IMAGES}/0/drivethru-snapshot-thumbnail-0.jpg`

  return (
    <div>
      <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
        SnapShot
      </h1>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Button
        variant="outlined"
        className="my-2"
        onClick={() => getPreSellBoardImages()}
      >
        Refresh Snapshot
      </Button>
      <div className="py-2">
        {(data?.thumbnail_image || tourEnabled) ? (
          <img
            src={tourEnabled ? tourGuideImg : data?.thumbnail_image}
            key={`${data?.actual_image} ${loading}`}
            className="cursor-pointer"
            style={{ width: "170px", height: "125px" }}
            onError={(event) => {
              event.target.src = "../assets/icons/notfound.png";
              event.onerror = null;
            }}
            alt="thumbnail"
            onClick={() => handleFullImage()}
          />
        ) : (
          <img
            src={"../assets/icons/notfound.png"}
            style={{ width: "170px", height: "125px" }}
            alt="thumbnail"
          />
        )}
      </div>
    </div>
  );
};

export default Snapshot;
